import React, { useEffect, useState } from 'react';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  IconSpinner,
  Page,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import css from './WineryPage.module.css';
import imgSrc from './winery.jpg';
import oregonWinerySrc from '../../assets/oregonWinery.jpg';
import SommlyScore from './SommlyScore/SommlyScore';
import AboutSignorVineyards from './AboutSignorVineyards/AboutSignorVineyards';
import BuyWineDirect from './BuyWineDirect/BuyWineDirect';
import WineryTeam from './WineryTeam/WineryTeam';
import VineyardReviews from './VineyardReviews/VineyardReviews';
import InstagramFeed from './InstagramFeed/InstagramFeed';
import YouMightAlsoLike from './YouMightAlsoLike/YouMightAlsoLike';
import { getWinery, getWineryBySlug } from '../../services/winery';
import WineryNotClaimedYetMessage from './WineryNotClaimedYetMessage/WineryNotClaimedYetMessage';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getMyFavorites } from '../../services/favorite';
import Slider from 'react-slick';
import ReactPlayer from 'react-player/lazy';
import { BsFillPauseCircleFill, BsFillPlayCircleFill } from 'react-icons/bs';
import { getMyWineryTeam } from '../../services/team';
import { getMyWineryInstafeed } from '../../services/instafeed';
import { getListingsById } from './WineryPage.duck';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { useMemo } from 'react';
import { getWineryReviews } from '../../services/review';
import { getWineryAwards } from '../../services/award';
import { charLimit } from '../../util/charLimit';
import { isScrollingDisabled } from '../../ducks/UI.duck';

const WineryPage = ({
  currentUser,
  queryInProgress: wineryListingsLoading,
  wines: wineryWinesProps,
  params,
  intl,
  winery,
  schema,
  wineryLoading: loading,
  scrollingDisabled,
}) => {
  const { slug } = params;
  const [favWineries, setFavWineries] = useState([]);
  const [isMyFav, setIsMyFav] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [team, setTeam] = useState([]);
  const [teamLoading, setTeamLoading] = useState(false);
  const [instafeed, setInstafeed] = useState(null);
  const [instafeedLoading, setInstafeedLoading] = useState(false);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [awards, setAawards] = useState([]);
  const [awardsLoading, setAawardsLoading] = useState([]);
  // map state
  const [locations, setLocations] = useState(null);
  const [wineryWines, setWineryWines] = useState([]);
  useEffect(() => {
    if (currentUser) {
      getMyFavorites(currentUser.expresUserId, setFavWineries);
    }
  }, [currentUser]);

  useEffect(() => {
    if (winery) {
      const wineryId = winery?._id;
      getWineryReviews(wineryId, setReviewsLoading, setReviews);
    }
  }, [winery]);

  useEffect(() => {
    if (favWineries.length > 0) {
      favWineries.forEach(fav => {
        if (fav.winery?._id === winery?._id) {
          setIsMyFav(true);
        }
      });
    }
  }, [favWineries]);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    speed: 800,
    autoplaySpeed: 800,
    dots: false,
  };

  useEffect(() => {
    if (winery !== null) {
      const obj = {
        id: winery._id,
        slug: winery.slug,
        name: winery.name,
        city: winery.city,
        address: winery.street,
        state: winery.state,
        lat: Number(winery.lat),
        lng: Number(winery.lng),
      };
      setLocations([obj]);

      // get my winery awards
      getWineryAwards(winery._id, setAawardsLoading, setAawards);
      // get winery team
      getMyWineryTeam(winery._id, setTeamLoading, setTeam);
      // get winery instafeed
      getMyWineryInstafeed(winery._id, setInstafeedLoading, setInstafeed);
    }
  }, [winery]);

  const topbar = <TopbarContainer />;

  if (loading || winery === null) {
    return (
      <Page title="Loading Winery...!" scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div className={css.spinnerWrapper}>
              <IconSpinner />
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schema.title}
      contentType="website"
      description={schema.description}
      facebookImages={schema.facebookImages}
      twitterImages={schema.twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Winery',
        description: schema.description,
        name: schema.title,
        image: schema.images,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <>
            <div className={css.topBanner}>
              <div className={css.leftSide}>
                <div className={css.leftSideContent}>
                  <h1>{winery.name}</h1>
                  <span>{winery.slogan}</span>
                  <p>{charLimit(winery?.short_description, 450)}</p>
                  <h5>Annual Production: {winery?.searchMeta.production} Cases </h5>
                </div>
              </div>
              <div className={css.rightSide}>
                {winery.photo.length > 0 || winery.video.length > 0 ? (
                  <Slider {...settings}>
                    {winery.photo.map((p, index) => (
                      <div key={index} className={css.imageWrapper}>
                        <img src={p.Location} alt="" style={{ height: 'auto' }} />
                      </div>
                    ))}
                    {winery.video.map((v, index) => (
                      <div key={index} className={css.videoWrapper}>
                        <ReactPlayer
                          url={v.Location}
                          playing={playing}
                          controls={false}
                          width="100%"
                          height="100%"
                          onEnded={() => setPlaying(false)}
                        />
                        <div className={css.playBtn}>
                          {playing ? (
                            <BsFillPauseCircleFill
                              onClick={() => setPlaying(false)}
                              style={{ color: '#fff', fontSize: '40px', cursor: 'pointer' }}
                            />
                          ) : (
                            <BsFillPlayCircleFill
                              onClick={() => setPlaying(true)}
                              style={{ color: '#fff', fontSize: '40px', cursor: 'pointer' }}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  winery.state === 'Oregon' ? (<img src={oregonWinerySrc} alt="" />) : (<img src={imgSrc} alt="" />) 
                )}
              </div>
            </div>

            <div>
              <SommlyScore winery={winery} reviews={reviews} awards={awards} />
            </div>
            <div>
              <AboutSignorVineyards
                winery={winery}
                locations={locations}
                currentUser={currentUser}
                isMyFav={isMyFav}
                setIsMyFav={setIsMyFav}
              />
            </div>
            {winery?.claimed === 'claimed' ? (
              <>
                <div>
                  {wineryWinesProps.length > 0 ? (
                    <BuyWineDirect
                      wines={wineryWinesProps}
                      winesLoading={wineryListingsLoading}
                      intl={intl}
                      winery={winery}
                      currentUser={currentUser}
                    />
                  ) : null}
                </div>
                <div>{team.length > 0 ? <WineryTeam team={team} /> : null}</div>
              </>
            ) : (
              <WineryNotClaimedYetMessage winery={winery} />
            )}
            {winery?.claimed === 'claimed' ? (
              <div>
                {console.log(instafeed)}
                {instafeed !== null ? (
                  <InstagramFeed winery={winery} instafeed={instafeed} />
                ) : null}
              </div>
            ) : null}
            <div>
              <VineyardReviews
                winery={winery}
                reviews={reviews}
                setReviews={setReviews}
                reviewsLoading={reviewsLoading}
                setReviewsLoading={setReviewsLoading}
                currentUser={currentUser}
              />
            </div>
            <div>
              <YouMightAlsoLike />
            </div>
          </>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    winery,
    wineryLoading,
    wineryErrors,
    schema,
  } = state.WineryPage;

  // const wineryId = queryParams?.pub_wineryId;

  // const listings = getListingsById(state, currentPageResultIds);
  const wines = getListingsById(state, currentPageResultIds);
  // const wines = listings.filter(l => l?.attributes.publicData.wineryId === wineryId);
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    wines,
    winery,
    schema,
    wineryLoading,
  };
};

export default compose(withRouter, connect(mapStateToProps), injectIntl)(WineryPage);
